import { render, staticRenderFns } from "./ProtocolView.vue?vue&type=template&id=ab672bae"
import script from "./ProtocolView.vue?vue&type=script&lang=js"
export * from "./ProtocolView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports